<template>
  <div @click.capture="isTimeOut" class="app">
    <router-view @hook:mounted="loaded"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      lastTime: null, // 最后一次点击的时间
      currentTime: null, // 当前点击的时间
      timeOut: 60 * 60 * 1000, // 设置超时时间:
    }
  },
  created () {
    this.lastTime = new Date().getTime();
  },
  methods: {
    loaded() {
      const dom = document.getElementById("loading");
      if (dom) {
        dom.style.opacity = "0";
        dom.style.visibility = "hidden"
      }
    },
    isTimeOut (event) {
      // 记录这次点击的时间
      this.currentTime = new Date().getTime();
      let interval = this.currentTime - this.lastTime;
      // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
      if (this.$store.state.token && interval > this.timeOut) {
        // 阻止事件传播
        event.stopPropagation();
        this.$router.push('/login').catch(() => {});
        this.msgError('认证超时，请重新登录！');
      }
      // 如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
      this.lastTime = new Date().getTime()
    }
  }
}
</script>

<style scoped lang="scss">
.app {
  height: 100%;
  overflow-y: hidden;
  overflow-x: auto;
}
</style>
